import React from 'react';

/**
 * Shield + Growth-arrow mark — same SVG the marketing site + favicon use.
 * Renders inline so it inherits container height; pass `size` for pixel width.
 */
const BrandLogo = ({ size = 32, className = '', showWordmark = true }) => (
  <div className={`inline-flex items-center gap-2 ${className}`} data-testid="brand-logo">
    <svg
      width={size}
      height={size}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-label="InsureGrowth"
    >
      {/* Shield body — brand green with a subtle darker outline for definition */}
      <path
        d="M24 3L6 9v14c0 11.6 7.7 21.4 18 24 10.3-2.6 18-12.4 18-24V9L24 3z"
        fill="var(--brand-green, #1CC15E)"
      />
      <path
        d="M24 3L6 9v14c0 11.6 7.7 21.4 18 24 10.3-2.6 18-12.4 18-24V9L24 3z"
        stroke="var(--brand-green-dark, #0B7A3C)"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      {/* Growth arrow / checkmark inside the shield — white so it pops */}
      <path
        d="M14 26 L21 33 L34 16"
        stroke="#FFFFFF"
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      {/* Small arrow-head tick to emphasize the "growth" direction */}
      <path
        d="M34 16 L34 22 M34 16 L28 16"
        stroke="#FFFFFF"
        strokeWidth="3"
        strokeLinecap="round"
        fill="none"
      />
    </svg>
    {showWordmark && (
      <span
        className="text-2xl font-bold"
        style={{ fontFamily: 'Manrope', color: 'var(--brand-green-dark, #0B7A3C)' }}
      >
        InsureGrowth
      </span>
    )}
  </div>
);

export default BrandLogo;
